// extracted by mini-css-extract-plugin
export default {"wraper":"JoinUs_wraper__thDvz","icons":"JoinUs_icons__yfNtd","icon":"JoinUs_icon__Kh4tI","paragrafOne":"JoinUs_paragrafOne__oaJAA","paragrafTwo":"JoinUs_paragrafTwo__6L5ot"};